import { apiFetch, readApiJson } from '@/lib/api-fetch'
import { ViewPresetListSchema, ViewPresetSchema, type ViewPresetResponse, type ViewSort } from '@/lib/api/schemas/views.schema'

export type ViewPresetOverrideRequest = {
  columns: readonly string[]
  sort: ViewSort
}

export async function getViewPresets(signal?: AbortSignal): Promise<readonly ViewPresetResponse[]> {
  const payload = ViewPresetListSchema.parse(await readApiJson(await apiFetch('/api/settings/view-presets', { signal })))
  return payload.presets
}

export async function putViewPreset(key: string, body: ViewPresetOverrideRequest, signal?: AbortSignal): Promise<ViewPresetResponse> {
  return ViewPresetSchema.parse(await readApiJson(await apiFetch(`/api/settings/view-presets/${encodeURIComponent(key)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal,
  })))
}

export async function deleteViewPreset(key: string, signal?: AbortSignal): Promise<void> {
  const response = await apiFetch(`/api/settings/view-presets/${encodeURIComponent(key)}`, { method: 'DELETE', signal })
  if (!response.ok) throw new Error(`Ошибка сброса пресета: ${response.status}`)
}
